import { useTranslation } from 'react-i18next';
import icon2 from '../../../assets/images/backoffice/kyc6.png';
import { SidebarSubtitle, SidebarTitle } from '../../../styles/stylesStyled';
import { Button } from '../../../styles/GlobalComponents';
import { useHistory } from 'react-router';
import { LOGIN } from '../../../routes/routes';

export const Success = () => {
  const history = useHistory();
  const { t } = useTranslation('settings');
  return (
    <div style={{ paddingTop: '12vh', textAlign: 'center' }}>
      <img src={icon2} alt='icon' style={{ marginBottom: 40, width: 220 }} />
      <SidebarTitle> {t('email.success')} </SidebarTitle>
      <SidebarSubtitle>{t('email.success_message')}</SidebarSubtitle>
      <Button onClick={() => history.push(LOGIN)} maxWidth='200px'>
        {t('email.login')}
      </Button>
    </div>
  );
};
